import axios from 'axios'

export const getIbisWorldData = (companyId) =>
    axios.get(`company/${companyId}/ibis-world-data`)
        .then(({ data }) => data)
